module.exports = __webpack_public_path__ + "f9baf67668140427d1f7f148a25ef837.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/skaters-shack-empty.png
// module id = 2867
// module chunks = 0